<template>
    <li class="nav-item dropdown d-flex align-items-center me-3 ">
        <a id="sideFilterButton" class="p-0 nav-link" :class="[textWhite ? textWhite : 'text-body', showMenu ? 'show' : '']"
            data-bs-toggle="offcanvas" role="button" :href="`#${id}`" :aria-controls=id>
            <img class="cursor-pointer" src="../../assets/img/icons/fontawesome/filter-regular.svg" alt="Filtro">
        </a>
    </li>
</template>

<script>

export default {
    name: "FilterButton",
    props: {
        id: {
            type: String,
            default: ""
        },
        required: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            textWhite: false,
            showMenu: false,
        }
    },
};
</script>

<style scoped>
.nav-item {
    border: 1px solid rgba(255, 255, 255, 0.22) !important;
    border-radius: 12px !important;
    min-width: 38.4px;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}

.nav-item:hover {
    border-color: var(--blue-accent) !important;
    background-color: rgba(255, 255, 255, 0.06);
}

.nav-item img {
    width: 14px;
    height: 14px;
    margin: 0.5rem 0.75rem;
    opacity: 0.9;
    /* icono en blanco para el navbar oscuro */
    filter: brightness(0) invert(1);
}

.nav-item:hover img {
    opacity: 1;
}
</style>
